import React from 'react';
import { ProjectDetailsFieldType } from 'nekst-api';
import Dropdown from '../../../shared/uibuilder/form/input/Dropdown';
import useProjectDetailsFieldTypeHelper from '../projectDetailsFieldTypeHelper';
import useInputHelper from '../../../shared/uibuilder/form/input/inputHelper';
import BaseInputLayoutWidget from '../../../shared/uibuilder/form/layout/BaseInputLayoutWidget';

export default function ProjectDetailsFieldTypeDropdown(
  props: {
    source: string,
    label: string,
    onlyEditable?: boolean,
  },
) {
  return (
    <Dropdown
      source={props.source}
      label={props.label}
      options={[
        {
          value: ProjectDetailsFieldType.SHORT_TEXT,
          label: 'Text',
        },
        {
          value: ProjectDetailsFieldType.LONG_TEXT,
          label: 'Long Text',
        },
        ...!props.onlyEditable ? [{
          value: ProjectDetailsFieldType.PRICE,
          label: 'Currency',
        },
          {
            value: ProjectDetailsFieldType.DATE,
            label: 'Date',
          }] : [],
      ]}
    />
  );
}

export function ProjectDetailsFieldTypeFormInput(props: {
  source: string,
  label: string,
  value?: ProjectDetailsFieldType
}) {
  const inputHelper = useInputHelper<ProjectDetailsFieldType>(props);

  const projectDetailsFieldTypeHelper = useProjectDetailsFieldTypeHelper();

  if ([
    ProjectDetailsFieldType.SHORT_TEXT,
    ProjectDetailsFieldType.LONG_TEXT
  ].includes(inputHelper.getValue())) {
    return (
      <ProjectDetailsFieldTypeDropdown
        source={props.source}
        label={props.label}
        onlyEditable
      />
    )
  } else {
    return (
      <BaseInputLayoutWidget name={props.source} label={props.label}>
        <i>
          {projectDetailsFieldTypeHelper.getLabel(inputHelper.getValue())}
        </i>
      </BaseInputLayoutWidget>
    );
  }

}
